const getDataset = () =>
  window.dotsMapConfig.dataset || [
    {
      organization: "(AEMO) Australian Energy Market Operator",
      projectName: "Project EDGE",
      location: "Australia",
      "": "",
      projectType: "DER Management",
      description: "",
      linkText: "Learn More",
      urls: [
        {
          linkText: "See more",
          url: "https://www.energyweb.org/aemo/",
        },
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/aemo-announces-open-source-operating-system[…]orld-leading-distributed-energy-marketplace-design-a211a6f6c415",
        },
        {
          linkText: "See more",
          url: "https://www.canarymedia.com/articles/solar/how-blockchain-could-help-integrate-rooftop-solar-and-evs-into-the-grid",
        },
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/canary-in-the-sunshine-australia-is-showing-the-rest-of-the-world-what-a-modern-grid-looks-like-ce95832cc017",
        },
      ],
    },
    {
      organization: "(APG) Austrian Power Grid",
      projectName: "APG FlexHub",
      location: "Austria",
      "": "",
      projectType: "DER Management",
      description: "Decentralized platform for flexibility and balancing",
      linkText: "Learn More",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/austrian-power-grid-and-energy-web-foundation-launch-proof-of-concept-to-use-distributed-energy-d9a378f5f5ee",
        },
      ],
    },
    {
      organization: "Bebat, Fluvius",
      projectName: "EasyBat",
      location: "Belgium",
      "": "",
      projectType: "Lifecycle Management",
      description: "",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://www.energyweb.org/technology/applications/ew-switchboard/easybat/",
        },
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/bebat-launches-easybat-an-open-source-decentralized-solution-for-battery-lifecycle-management-281f2ace61e9",
        },
      ],
    },
    {
      organization: "(CAISO) California Independent System Operator",
      projectName: "Flex Alert",
      location: "US",
      "": "",
      projectType: "DER Management",
      description: "",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/california-grid-operator-launches-new-demand-flexibility-platform-enhancements-to-flex-alert-system-e01ae8030da0",
        },
      ],
    },
    {
      organization: "Community Electricity",
      projectName: "Basset-Avocado Advanced Energy Community",
      location: "US",
      "": "",
      projectType: "DER Management",
      description: "Enabling co-optimization of DER in LMI communities",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/community-electricity-and-energy-web-announce-partnership-to-bring-decentralized-tech-to-2f105150a3db",
        },
      ],
    },
    {
      organization: "(DENA) Deutsche Energie-Agentur",
      projectName: "Digital DER Registry",
      location: "Germany",
      "": "",
      projectType: "DER Management",
      description: "",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/dena-selects-energy-web-to-build-prototype-identity-registry-for-germanys-energy-market-2580f53b2d20",
        },
      ],
    },
    {
      organization: "Electra Caldense, Bamboo Energy",
      projectName: "ElectraFlex",
      location: "Spain",
      "": "",
      projectType: "DER Management",
      description: "",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/catalonian-grid-operator-electra-caldense-energy-web-and-bamboo-energy-announce-grid-flexibility-51c75e5bcc25",
        },
      ],
    },
    {
      organization: "Elia Group",
      projectName: "EV Dashboard",
      location: "Belgium, Germany",
      "": "",
      projectType: "DER Management",
      description: "",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/elia-group-and-energy-web-launch-multi-year-strategic-partnership-be2c5d87395f",
        },
      ],
      caseStudy:
        "https://medium.com/energy-web-insights/elia-group-and-energy-web-launch-multi-year-strategic-partnership-be2c5d87395f",
    },
    {
      organization: "Energy Peace Partners",
      projectName: "Peace RECs (P-RECs)",
      location: "Sub-Saharan Africa",
      "": "",
      projectType: "Traceability",
      description:
        "Origin issuer and marketplace PoC for verified renewables in fragile countries and conflict zones. Building new digitized P-REC forward agreement solution.",
      linkText: "Learn More",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/energy-web-and-energy-peace-partners-announce-peace-renewable-energy-credit-p-rec-digital-6295ea233218",
        },
      ],
    },
    {
      organization: "ENGIE Energy Access",
      projectName: "DeFi Crowdfunding for Energy Access",
      location: "Sub-Saharan Africa",
      "": "",
      projectType: "",
      description: "",
      linkText: "Learn More",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/engie-energy-access-and-energy-web-announce-defi-crowdfunding-platform-to-help-scale-solar-mini-2142029ad84f#:~:text=Energy%20Web%20is%20a%20global,participate%20in%20any%20energy%20market",
        },
        {
          linkText: "See more",
          url: "https://lab.energyweb.org/engie-energy-access/",
        },
      ],
    },
    {
      organization: "FlexiDAO",
      projectName: "FlexiDAO",
      location: "Europe",
      "": "",
      projectType: "",
      description: "",
      linkText: "Learn More",
      urls: [
        {
          linkText: "See more",
          url: "https://www.flexidao.com/",
        },
      ],
    },
    {
      organization: "Fohat, AES Brazil",
      projectName: "I-REC Marketplace",
      location: "Brazil",
      "": "",
      projectType: "Traceability",
      description: "",
      linkText: "Learn More",
      urls: [
        {
          linkText: "See more",
          url: "https://fohat.co/2020/07/14/partnership-with-aes-tiete-and-energy-web-for-brazil-first-blockchain-based-renewable-energy-trading-platform/",
        },
      ],
    },
    {
      organization: "Foton",
      projectName: "I-REC Marketplace",
      location: "Turkey",
      "": "",
      projectType: "Traceability",
      description:
        "Production EW Origin Marketplace in compliance with The I-REC Standard in Turkey",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/foton-and-energy-web-launch-blockchain-based-i-rec-marketplace-in-turkey-e2847db835f",
        },
      ],
    },
    {
      organization: "Good Energies Foundation",
      projectName: "Energy Web Zero",
      location: "Global",
      "": "",
      projectType: "Traceability",
      description:
        "Grant for Energy Web to develop EW Zero, a publicly accessible renewable energy search engine",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/energy-web-awarded-good-energies-foundation-grant-for-new-global-renewables-marketplace-794eaa7e14e0",
        },
      ],
    },
    {
      organization: "Google.org",
      projectName: "Google Impact Challenge",
      location: "Europe",
      "": "",
      projectType: "Other",
      description:
        "Creating a digital framework for coordinating distributed energy resources (DERs) across the transmission and distribution market interface of Europe’s power grid",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/google-backs-energy-web-to-harmonize-low-carbon-electricity-markets-across-europe-204c18cd2f12",
        },
      ],
    },
    {
      organization: "LO3 Energy",
      projectName: "Pando",
      location: "Global",
      "": "",
      projectType: "",
      description: "",
      linkText: "Learn More",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/lo3-energy-updates-pando-platform-migrates-to-energy-web-chain-d709ae0e5311",
        },
      ],
    },
    {
      organization: "Mercados Eléctricos",
      projectName: "I-REC Marketplace",
      location: "El Salvador",
      "": "",
      projectType: "Traceability",
      description:
        "Production EW Origin Marketplace in compliance with The I-REC Standard in Central America",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/central-american-electricity-retailer-mercados-el%C3%A9ctricos-and-energy-web-complete-first-stage-of-a147541c8c44",
        },
      ],
    },
    {
      organization: "Minden",
      projectName: "Energy Matching",
      location: "Japan",
      "": "",
      projectType: "Traceability",
      description:
        "Testing EWC for blockchain-based matching engine for producers and consumers of renewable energy",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/energy-web-foundation-and-minna-denryoku-conclude-test-of-blockchain-for-japanese-renewable-energy-bf0627a9ccff",
        },
      ],
    },
    {
      organization: "NV Energy",
      projectName: "PEC Marketplace",
      location: "US",
      "": "",
      projectType: "Traceability",
      description:
        "Responding to a Public Utility Commission of Nevada public docket, Energy Web is advising a PEC Marketplace PoC in Nevada that is built by Blockchains. Uses the Origin Issuer.",
      linkText: "Learn More",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/nv-energy-blockchains-llc-and-energy-web-announce-blockchain-pilot-for-nevadas-residential-bbf4571179da",
        },
      ],
    },
    {
      organization: "PJM EIS",
      projectName: "Generation Attribute Tracking System (GATS) Bulletin Board",
      location: "US",
      "": "",
      projectType: "Traceability",
      description:
        "PoC that uses the Origin Exchange that is integrated with the PJM GATS registry.",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://insidelines.pjm.com/pjm-eis-completes-blockchain-pilot-with-energy-web-foundation",
        },
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/pjm-eis-update-modernizing-a-legacy-u-s-rec-tracking-system-with-blockchain-based-technology-db0ad5a4f924",
        },
      ],
    },
    {
      organization: "Protocol Labs, Filecoin",
      projectName: "Proof of Green Mining",
      location: "Global",
      "": "",
      projectType: "",
      description: "",
      linkText: "Learn More",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/protocol-labs-and-energy-web-complete-first-showcase-of-an-open-source-solution-to-decarbonize-1a8c22ac02f5",
        },
      ],
    },
    {
      organization: "PTT",
      projectName: "I-REC Marketplace",
      location: "Thailand",
      "": "",
      projectType: "Traceability",
      description: "Production EW Origin Marketplace in Thailand",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://energyweb.org/2019/09/11/ptt-and-energy-web-foundation-launch-blockchain-based-renewables-platform-for-thailand-asean-japan/",
        },
      ],
    },
    {
      organization: "Riddle&Code Energy Solutions",
      projectName: "MyPower",
      location: "Austria",
      "": "",
      projectType: "Other",
      description: "",
      linkText: "Learn More",
      urls: [
        {
          linkText: "See more",
          url: "https://www.riddleandcode.com/smart-energy",
        },
        {
          linkText: "See more",
          url: "https://www.ledgerinsights.com/wien-energie-riddlecode-tokenize-renewable-energy-installations-blockchain/",
        },
      ],
    },
    {
      organization: "Ripple & XRP Foundation",
      projectName: "Blockchain Decarbonization",
      location: "Global",
      "": "",
      projectType: "",
      description: "",
      linkText: "Learn More",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/xrp-ledger-foundation-ripple-and-energy-web-announce-worlds-first-decarbonized-blockchain-5c3cecbff31a",
        },
      ],
    },
    {
      organization: "Share&Charge",
      projectName: "Open Charging Network (OCN)",
      location: "",
      "": "",
      projectType: "E-Mobility",
      description: "",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/share-charge-foundation-launches-open-charging-network-on-energy-web-chain-84af7f6f5b3c",
        },
      ],
    },
    {
      organization: "Sonnen",
      projectName: "Proof of Green Storage",
      location: "Germany",
      "": "",
      projectType: "Traceability",
      description:
        "Onboarding storage assets on the grid and storing excess renewable energy",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/sonnen-leverages-energy-web-chain-ew-origin-for-virtual-power-plant-that-saves-wind-energy-862d54df4bed",
        },
      ],
    },
    {
      organization: "Stedin",
      projectName: "Stedin Layered Energy System",
      location: "Netherlands",
      "": "",
      projectType: "DER Management",
      description: "",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "",
        },
      ],
    },
    {
      organization: "SunSpec Alliance",
      projectName: "EW-DOS SunSpec Modbus Extension",
      location: "US",
      "": "",
      projectType: "DER Management",
      description: "Solar + Storage ‘Plug & Play’ Solutions",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/sunspec-alliance-joins-energy-web-announces-strategic-partnership-43c8438f199d",
        },
      ],
    },
    {
      organization: "The Energy Origin",
      projectName: "The Energy Origin (TEO)",
      location: "Europe",
      "": "",
      projectType: "",
      description: "",
      linkText: "Learn More",
      urls: [
        {
          linkText: "See more",
          url: "https://theenergyorigin.com/",
        },
        {
          linkText: "See more",
          url: "https://energyweb.org/2019/09/19/blockchain-teo-the-energy-origin-is-the-first-application-to-migrate-onto-the-energy-web-chain/",
        },
      ],
    },
    {
      organization: "The I-REC Standard",
      projectName: "I-REC Registry Integration",
      location: "Global",
      "": "",
      projectType: "",
      description: "",
      linkText: "Learn More",
      urls: [
        {
          linkText: "See more",
          url: "",
        },
      ],
    },
    {
      organization: "Vodafone Business",
      projectName:
        "SIM-centric blockchain technology (SCB) for IoT connectivity",
      location: "Global",
      "": "",
      projectType: "DER Management",
      description: "",
      linkText: "Learn more",
      urls: [
        {
          linkText: "See more",
          url: "https://medium.com/energy-web-insights/vodafone-business-and-energy-web-collaborate-to-bring-iot-and-blockchain-technologies-to-renewable-aac4d68502de",
        },
      ],
    },
  ];

export default getDataset;
